import React, { useEffect, FC } from "react";
import { Table, Button, Input, Tooltip, message } from "antd";
import { YHModal } from "@/components/YHModal";
import { useSaleRoDetailModel, IMaterialDetailModel } from "./saleRoDetailModel";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { RouterParamType } from "@/model/navModel";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { YhBut } from "@/components/YhButton";
import { formatNum, formatIntPoint, formatIntPoint1 } from "@/utils/utils";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";

enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const AddGoodsModal: FC<RouterParamType> = ({ id, mode }) => {
    const { shopAndOrg: { shopId }, user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const { initPgCfg, addModalVisible: visible,
        workDataSource,
        workPgCfg,
        detailAddForm,
        detailEditForm,
        addDataSource,
        searchWorkData,
        detailAddList,
        detailDataSource,
        setWorkDataSource,
        resetWorkloadData,
        setSearchWorkData,
        setAddDataSource,
        transformsToPoDetailList,
        workloadData,
        setAddModalVisible
    } = useSaleRoDetailModel();
    useEffect(() => {
        if (visible && mode === "add") {
            const { customerCode, bentityCode } = detailAddForm
            workloadData(initPgCfg, { customerCode, bentityCode })
            setSearchWorkData({ customerCode, bentityCode })
        } else if (visible && mode === "edit") {
            const { customerCode, bentityCode } = detailEditForm
            workloadData(initPgCfg, { customerCode, bentityCode })
            setSearchWorkData({ customerCode, bentityCode })
        }
    }, [detailAddForm?.customerCode, detailEditForm.customerCode, detailAddForm?.bentityCode, detailEditForm.bentityCode, visible])


    const column = (optype: number) => [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '商品编号',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '商品名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '销售单号',
            width: 120,
            dataIndex: 'saleCode',
        }, {
            title: '销售数量',
            width: 100,
            dataIndex: 'saleNum',
        }, {
            title: '销售单价',
            width: 100,
            dataIndex: 'salePrice',
        }, {
            title: '折扣',
            width: 100,
            dataIndex: 'discountRate',
            render: (text: string) => text + '%'
        }, {
            title: '单项优惠金额',
            width: 140,
            dataIndex: 'decreaseAmount',
        }, {
            title: '销售金额',
            width: 100,
            dataIndex: 'saleTotal',

        }, {
            title: '退货数量',
            width: 100,
            dataIndex: 'num',
            editable: true,
        }, {
            title: '退货单价',
            width: 100,
            dataIndex: 'price',
            editable: true,
        }, {
            title: '退货折扣',
            width: 100,
            dataIndex: 'discountRate',
            render: (text: string) => text + '%'
        }, {
            title: '退货金额',
            width: 100,
            dataIndex: 'amount',
        }, {
            title: '已退数量',
            width: 100,
            dataIndex: 'sreturnNum',
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            className: "td-wrap",
            render: (text: string, record: IMaterialDetailModel) => optype === OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    txt="添加"
                    click={() => add(record)}
                    disabled={
                        !!addDataSource.find(item => item.id === record.id)
                        || record.sreturnNum === record.saleNum
                        || !!addDataSource.find(item => item.saleCode !== record.saleCode)
                        || !!(mode === "edit" ? detailDataSource : detailAddList).find(item => item.saleCode !== record.saleCode)
                    }
                />
            ) : (
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => remove(record)}
                />
            )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailModel, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType === OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })

    const roleColumns = (optType: number) => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "saleReturn", "roleCodes": roles };
        return getRoleColumns("saleReturn", "新增商品", newSelectColumns(optType), params);
    };

    const notHandleSave = (row: IMaterialDetailModel) => {
        let { num, price, sreturnNum, saleNum, discountRate, salePrice } = row as { salePrice: number, num: number, price: number, sreturnNum: number, saleNum: number, discountRate: number }
        saleNum = + formatNum(saleNum)
        sreturnNum = + formatNum(sreturnNum)
        price = +formatNum(price)
        if (price > +salePrice) {
            message.warning(`修改价格不应大于销售价格${salePrice}`)
            price = +formatNum(salePrice)
        }

        discountRate = +formatNum(discountRate)
        num = +formatIntPoint(num, saleNum - sreturnNum, "退货数量>销售数量")
        let newRow = {
            ...row,
            num,
            price,
            amount: +formatNum((num * price * discountRate) / 100)
        }
        const index = workDataSource.findIndex((item) => row.id === item.id);
        const item = workDataSource[index];
        workDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkDataSource([...workDataSource])
    }
    const handleSave = (row: IMaterialDetailModel) => {
        let { num, price, sreturnNum, saleNum, discountRate, salePrice } = row as { salePrice: number, num: number, price: number, sreturnNum: number, saleNum: number, discountRate: number }
        saleNum = + formatNum(saleNum)
        sreturnNum = + formatNum(sreturnNum)
        price = +formatNum(price)
        if (price > +salePrice) {
            message.warning(`修改价格不应大于销售价格${salePrice}`)
            price = +formatNum(salePrice)
        }
        discountRate = +formatNum(discountRate)
        num = +formatIntPoint(num, saleNum - sreturnNum, "退货数量>销售数量")
        let newRow = {
            ...row,
            num,
            price,
            amount: +formatNum((num * price * discountRate) / 100)
        }
        const index = addDataSource.findIndex((item) => row.id === item.id);
        const item = addDataSource[index];
        addDataSource.splice(index, 1, { ...item, ...newRow });
        setAddDataSource([...addDataSource])
    }
    const add = async (record: IMaterialDetailModel) => {
        setAddDataSource(origin => [...origin, record])
    }
    const remove = async (record: IMaterialDetailModel) => {
        const filterAddDataSource = addDataSource.filter(item => item.id !== record.id)
        setAddDataSource(filterAddDataSource)
    }
    const onOK = async () => {
        transformsToPoDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setAddModalVisible(false);
        setAddDataSource([]);
        mode === "add" ? resetWorkloadData({ customerCode: detailAddForm.customerCode, bentityCode: detailAddForm.bentityCode }) : resetWorkloadData({ customerCode: detailEditForm.customerCode, bentityCode: detailEditForm.bentityCode })

    };
    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialCode}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialCode: e.target.value }) }}
            onBlur={(e) => { setSearchWorkData({ ...searchWorkData, materialCode: e.target.value?.trim() }) }}
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder="商品编码"
        />
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialName}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialName: e.target.value?.trim() }) }}
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder="商品名称"
        />
        <Button onClick={() => workloadData()} style={{ margin: "0px 5px 0px 10px" }} shape="round">检索</Button>
        <Button onClick={() => mode === "add" ? resetWorkloadData({ customerCode: detailAddForm.customerCode, bentityCode: detailAddForm.bentityCode }) : resetWorkloadData({ customerCode: detailEditForm.customerCode, bentityCode: detailEditForm.bentityCode })} shape="round">重置</Button>
    </div>

    return <YHModal
        visible={visible}
        onOk={onOK}
        onCancel={onCancel}
        title="销售退货单-选择配件"
        width={'70%'}
        bodyHeight={730}
        showFooter={true}
    >
        <YhBox title="待选配件列表" rightChildren={rightChildren} style={{ marginBottom: "15px" }}>
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.id as string}
                columns={roleColumns(OPT_TYPE.ADD) as ColumnsType<IMaterialDetailModel>}
                dataSource={workDataSource}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                pagination={{
                    ...workPgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        workloadData({ pageNum, pageSize });
                    }
                }}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title="已选配件列表">
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.id as string}
                columns={roleColumns(OPT_TYPE.REMOVE) as ColumnsType<IMaterialDetailModel>}
                dataSource={[...addDataSource]}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                pagination={false}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}